import React, { useState, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import Sidebar from './components/sidebar';
import { useNavigate } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
// Importar imágenes desde assets (mismas que en Membresias)
import m1Image from './assets/udgrade/m1.png';
import m2Image from './assets/udgrade/m2.png';
import m3Image from './assets/udgrade/m3.png';

const Cirpacademy = () => {
  const navigate = useNavigate();
  const [cursos, setCursos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showMembresias, setShowMembresias] = useState(true);
  const [membresiaSeleccionada, setMembresiaSeleccionada] = useState(null);
  const [showMembresia2Menu, setShowMembresia2Menu] = useState(false);
  const [showMembresia3Menu, setShowMembresia3Menu] = useState(false);
  const [categoriaFiltro, setCategoriaFiltro] = useState(null); // null = todas, 'academia', 'mentoria', 'certificacion'
  const [userMembresia, setUserMembresia] = useState(null); // Membresía real del usuario
  const [categoriasPermitidas, setCategoriasPermitidas] = useState([]); // Categorías permitidas según membresía

  // Obtener membresía del usuario
  useEffect(() => {
    const obtenerMembresia = async () => {
      try {
        const loginUserJSON = window.localStorage.getItem('loginUser');
        if (loginUserJSON) {
          const user = JSON.parse(loginUserJSON);
          if (user.id) {
            const response = await axios.get(`https://api.mrcirp.com/public/userpanel/${user.id}`);
            if (response.data && response.data[0]) {
              const membresia = response.data[0].membresia;
              setUserMembresia(membresia);
              
              // Definir categorías permitidas según membresía
              let permitidas = [];
              if (membresia === 'Katana Demo' || membresia === 'Katana Basic') {
                permitidas = ['academia'];
              } else if (membresia === 'Katana Pro') {
                permitidas = ['academia', 'mentoria'];
              } else if (membresia === 'Katana Premium') {
                permitidas = ['academia', 'mentoria', 'certificacion'];
              } else {
                // Si no tiene membresía o es admin, permitir todas
                permitidas = ['academia', 'mentoria', 'certificacion'];
              }
              setCategoriasPermitidas(permitidas);
            }
          }
        }
      } catch (err) {
        console.warn('Error al obtener membresía:', err);
        // Si hay error, permitir todas las categorías
        setCategoriasPermitidas(['academia', 'mentoria', 'certificacion']);
      }
    };

    obtenerMembresia();
  }, []);

  useEffect(() => {
    const fetchCursos = async () => {
      try {
        const response = await axios.get('https://api.mrcirp.com/public/cursos');
        setCursos(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchCursos();
  }, []);

  const handleCardClick = (cursoId) => {
    navigate(`/modulo/${cursoId}`);
  };

  // Función para verificar si el usuario tiene acceso a una membresía
  const verificarAccesoMembresia = (membresia) => {
    if (!userMembresia) return true; // Si no hay membresía definida, permitir acceso (admin)
    
    if (membresia === 'c1') {
      // Basic - accesible para Demo y Basic
      return userMembresia === 'Katana Demo' || userMembresia === 'Katana Basic';
    } else if (membresia === 'c2') {
      // Pro - accesible para Pro y Premium
      return userMembresia === 'Katana Pro' || userMembresia === 'Katana Premium';
    } else if (membresia === 'c3') {
      // Premium - solo accesible para Premium
      return userMembresia === 'Katana Premium';
    }
    
    return false;
  };

  const handleAccederMembresia = (membresia) => {
    setMembresiaSeleccionada(membresia);
    setCategoriaFiltro(null); // Resetear filtro de categoría
    
    // Verificar si el usuario tiene acceso a esta membresía
    const tieneAcceso = verificarAccesoMembresia(membresia);
    
    if (!tieneAcceso) {
      alert('No tienes acceso a esta membresía. Tu membresía actual es: ' + (userMembresia || 'No definida'));
      return;
    }
    
    if (membresia === 'c2') {
      setShowMembresia2Menu(true);
      setShowMembresia3Menu(false);
      setShowMembresias(false);
    } else if (membresia === 'c3') {
      setShowMembresia3Menu(true);
      setShowMembresia2Menu(false);
      setShowMembresias(false);
    } else {
      setShowMembresia2Menu(false);
      setShowMembresia3Menu(false);
      setShowMembresias(false);
      // Para Basic/Demo, mostrar solo academia
      setCategoriaFiltro('academia');
    }
  };

  const handleAccederAcademy = () => {
    if (!categoriasPermitidas.includes('academia')) {
      alert('No tienes acceso a Academia con tu membresía actual.');
      return;
    }
    setShowMembresia2Menu(false);
    setShowMembresia3Menu(false);
    setCategoriaFiltro('academia');
  };

  const handleAccederMentorias = () => {
    if (!categoriasPermitidas.includes('mentoria')) {
      alert('No tienes acceso a Mentorías con tu membresía actual.');
      return;
    }
    setShowMembresia2Menu(false);
    setShowMembresia3Menu(false);
    setCategoriaFiltro('mentoria');
  };

  const handleAccederCertificaciones = () => {
    if (!categoriasPermitidas.includes('certificacion')) {
      alert('No tienes acceso a Certificaciones con tu membresía actual.');
      return;
    }
    setShowMembresia2Menu(false);
    setShowMembresia3Menu(false);
    setCategoriaFiltro('certificacion');
  };

  // Si está mostrando el menú de membresía 2, mostrar la pantalla intermedia
  if (showMembresia2Menu) {
    return (
      <div>
        <Sidebar>
          <div className="container mt-4">
            <div className="mb-3">
              <Button 
                variant="secondary" 
                onClick={() => {
                  setShowMembresia2Menu(false);
                  setShowMembresias(true);
                }}
                className="mb-3"
              >
                ← Volver a Membresías
              </Button>
            </div>
            <Row className="justify-content-center">
              <Col md={6} className="mb-4">
                <Card className="h-100 text-center" style={{ border: '2px solid #e0e0e0', borderRadius: '10px' }}>
                  <Card.Img 
                    variant="top" 
                    src={m2Image} 
                    style={{ objectFit: 'contain', padding: '20px', backgroundColor: '#fff' }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>KATANA PRO</Card.Title>
                    <div className="mt-auto pt-4">
                      <Row className="g-3">
                        <Col xs={12} sm={6}>
                          <h6 className="mb-2" style={{ fontSize: '0.9rem' }}>Academy</h6>
                          <Button 
                            variant="primary" 
                            size="sm" 
                            className="w-100"
                            onClick={handleAccederAcademy}
                          >
                            Acceder
                          </Button>
                        </Col>
                        <Col xs={12} sm={6}>
                          <h6 className="mb-2" style={{ fontSize: '0.9rem' }}>Mentorías</h6>
                          <Button 
                            variant={categoriasPermitidas.includes('mentoria') ? "primary" : "secondary"}
                            size="sm" 
                            className="w-100"
                            onClick={handleAccederMentorias}
                            disabled={!categoriasPermitidas.includes('mentoria')}
                          >
                            {categoriasPermitidas.includes('mentoria') ? 'Acceder' : 'No disponible'}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </Sidebar>
      </div>
    );
  }

  // Si está mostrando el menú de membresía 3, mostrar la pantalla intermedia
  if (showMembresia3Menu) {
    return (
      <div>
        <Sidebar>
          <div className="container mt-4">
            <div className="mb-3">
              <Button 
                variant="secondary" 
                onClick={() => {
                  setShowMembresia3Menu(false);
                  setShowMembresias(true);
                }}
                className="mb-3"
              >
                ← Volver a Membresías
              </Button>
            </div>
            <Row className="justify-content-center">
              <Col md={6} className="mb-4">
                <Card className="h-100 text-center" style={{ border: '2px solid #e0e0e0', borderRadius: '10px' }}>
                  <Card.Img 
                    variant="top" 
                    src={m3Image} 
                    style={{ objectFit: 'contain', padding: '20px', backgroundColor: '#fff' }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>KATANA PREMIUM</Card.Title>
                    <div className="mt-auto pt-4">
                      <Row className="g-3">
                        <Col xs={12} sm={4}>
                          <h6 className="mb-2" style={{ fontSize: '0.9rem' }}>Academy</h6>
                          <Button 
                            variant="primary" 
                            size="sm" 
                            className="w-100"
                            onClick={handleAccederAcademy}
                          >
                            Acceder
                          </Button>
                        </Col>
                        <Col xs={12} sm={4}>
                          <h6 className="mb-2" style={{ fontSize: '0.9rem' }}>Mentorías</h6>
                          <Button 
                            variant={categoriasPermitidas.includes('mentoria') ? "primary" : "secondary"}
                            size="sm" 
                            className="w-100"
                            onClick={handleAccederMentorias}
                            disabled={!categoriasPermitidas.includes('mentoria')}
                          >
                            {categoriasPermitidas.includes('mentoria') ? 'Acceder' : 'No disponible'}
                          </Button>
                        </Col>
                        <Col xs={12} sm={4}>
                          <h6 className="mb-2" style={{ fontSize: '0.9rem' }}>Certificaciones</h6>
                          <Button 
                            variant={categoriasPermitidas.includes('certificacion') ? "primary" : "secondary"}
                            size="sm" 
                            className="w-100"
                            onClick={handleAccederCertificaciones}
                            disabled={!categoriasPermitidas.includes('certificacion')}
                          >
                            {categoriasPermitidas.includes('certificacion') ? 'Acceder' : 'No disponible'}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </Sidebar>
      </div>
    );
  }

  // Si está mostrando membresías, mostrar la página inicial
  if (showMembresias) {
    return (
      <div>
        <Sidebar>
          <div className="container mt-4">
            <h2 className="text-center mb-4">Selecciona tu Membresía</h2>
            <Row className="justify-content-center">
              <Col md={4} className="mb-4">
                <Card className="h-100 text-center" style={{ border: '2px solid #e0e0e0', borderRadius: '10px' }}>
                  <Card.Img 
                    variant="top" 
                    src={m1Image} 
                    style={{ objectFit: 'contain', padding: '20px', backgroundColor: '#fff' }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>KATANA BASIC</Card.Title>
                    <div className="mt-auto pt-3">
                      <Button 
                        variant={verificarAccesoMembresia('c1') ? "primary" : "secondary"}
                        size="lg" 
                        className="w-100"
                        onClick={() => handleAccederMembresia('c1')}
                        disabled={!verificarAccesoMembresia('c1')}
                      >
                        {verificarAccesoMembresia('c1') ? 'Acceder' : 'No disponible'}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} className="mb-4">
                <Card className="h-100 text-center" style={{ border: '2px solid #e0e0e0', borderRadius: '10px' }}>
                  <Card.Img 
                    variant="top" 
                    src={m2Image} 
                    style={{ objectFit: 'contain', padding: '20px', backgroundColor: '#fff' }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>KATANA PRO</Card.Title>
                    <div className="mt-auto pt-3">
                      <Button 
                        variant={verificarAccesoMembresia('c2') ? "primary" : "secondary"}
                        size="lg" 
                        className="w-100"
                        onClick={() => handleAccederMembresia('c2')}
                        disabled={!verificarAccesoMembresia('c2')}
                      >
                        {verificarAccesoMembresia('c2') ? 'Acceder' : 'No disponible'}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={4} className="mb-4">
                <Card className="h-100 text-center" style={{ border: '2px solid #e0e0e0', borderRadius: '10px' }}>
                  <Card.Img 
                    variant="top" 
                    src={m3Image} 
                    style={{ objectFit: 'contain', padding: '20px', backgroundColor: '#fff' }}
                  />
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>KATANA PREMIUM</Card.Title>
                    <div className="mt-auto pt-3">
                      <Button 
                        variant={verificarAccesoMembresia('c3') ? "primary" : "secondary"}
                        size="lg" 
                        className="w-100"
                        onClick={() => handleAccederMembresia('c3')}
                        disabled={!verificarAccesoMembresia('c3')}
                      >
                        {verificarAccesoMembresia('c3') ? 'Acceder' : 'No disponible'}
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
        </Sidebar>
      </div>
    );
  }

  if (loading) {
    return (
      <Sidebar>
        <div className="container mt-4">
          <div className="text-center">Cargando cursos...</div>
        </div>
      </Sidebar>
    );
  }

  if (error) {
    return (
      <Sidebar>
        <div className="container mt-4">
          <div className="alert alert-danger">Error al cargar los cursos: {error}</div>
        </div>
      </Sidebar>
    );
  }

  return (
    <div>
      <Sidebar>
        <div className="container mt-4">
          <div className="mb-3">
            <div className="mb-3 d-flex gap-2">
              {(membresiaSeleccionada === 'c2' || membresiaSeleccionada === 'c3') && categoriaFiltro && (
                <Button 
                  variant="outline-secondary" 
                  onClick={() => {
                    if (membresiaSeleccionada === 'c2') {
                      setShowMembresia2Menu(true);
                    } else if (membresiaSeleccionada === 'c3') {
                      setShowMembresia3Menu(true);
                    }
                    setCategoriaFiltro(null);
                  }}
                  className="mb-3"
                >
                  ← Volver al Menú
                </Button>
              )}
              <Button 
                variant="secondary" 
                onClick={() => {
                  setShowMembresias(true);
                  setShowMembresia2Menu(false);
                  setShowMembresia3Menu(false);
                  setMembresiaSeleccionada(null);
                  setCategoriaFiltro(null);
                }}
                className="mb-3"
              >
                ← Volver a Membresías
              </Button>
            </div>
            {membresiaSeleccionada && (
              <p className="text-muted">
                Membresía seleccionada: {membresiaSeleccionada.toUpperCase()}
                {categoriaFiltro && ` - Categoría: ${categoriaFiltro.charAt(0).toUpperCase() + categoriaFiltro.slice(1)}`}
              </p>
            )}
          </div>
          <Row>
            {cursos
              .filter((curso) => {
                // Normalizar la categoría del curso
                const categoriaCurso = (curso.categoria || curso.categoria_curso || '').toLowerCase().trim();
                
                // Si hay un filtro de categoría específico, filtrar por ella
                if (categoriaFiltro) {
                  return categoriaCurso === categoriaFiltro.toLowerCase();
                }
                
                // Si no hay filtro específico, filtrar por categorías permitidas según membresía
                if (categoriasPermitidas.length > 0) {
                  return categoriasPermitidas.some(cat => categoriaCurso === cat.toLowerCase());
                }
                
                // Si no hay categorías permitidas definidas, mostrar todos (admin o sin membresía)
                return true;
              })
              .map((curso) => (
              <Col key={curso.id} md={4} className="mb-4">
                <Card 
                  onClick={() => handleCardClick(curso.id)}
                  style={{ cursor: 'pointer' }}
                  className="h-100"
                >
                  <Card.Img 
                    variant="top" 
                    src={curso.imagen || "https://via.placeholder.com/300x200?text=Sin+imagen"} 
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                  <Card.Body>
                    <Card.Title>{curso.nombrecurso || 'Curso sin título'}</Card.Title>
                    <Card.Text>
                      {curso.descripcion || 'Descripción no disponible'}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div>
      </Sidebar>
    </div>
  );
};

export default Cirpacademy;